import React, { ReactNode } from "react"
import { Stack, Typography } from "@mui/material"
import Image from "next/image"

const OverviewStatItem = ({
  icon,
  title,
  stat,
  statColor = "text-neutral-1000",
}: {
  icon: string
  title: string
  stat: string | ReactNode
  statColor?: string
}) => {
  return (
    <Stack
      direction={{ xs: "row", sm: "column" }}
      className='bg-gradient-box-status border border-solid border-secondary rounded-lg p-4 sm:p-6 gap-[6px] h-full'
    >
      <Image src={icon} alt='hero-stat-icon' className='sm:h-10 sm:w-10' width={36} height={36} />
      <Stack className='flex-1' gap={{ xs: 0, sm: 0.5 }}>
        <Typography className='text-xs sm:text-sm text-neutral-600'>{title}</Typography>
        <Typography className={`font-bold text-lg sm:text-xl ${statColor}`}>{stat}</Typography>
      </Stack>
    </Stack>
  )
}

export default OverviewStatItem
